import React, { useEffect, useState } from 'react';
import CustomButton from '../../../components/customButton';
import CustomCheckBox from '../../../components/customCheckBox';
import CustomInput from '../../../components/customInput';
import utils from '../../../utils';
import API from '../../../services/api';

const UserForm = ({ onSuccess, onError, onLoading }) => {
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [errors, setErrors] = useState({});

  const fields = {
    displayName,
    email,
    password,
    confirmPassword,
    agreed
  };

  const validation = {
    displayName: [
      { key: 'required', value: true },
      { key: 'min', value: 4 }
    ],
    email: [
      { key: 'required', value: true },
      { key: 'email', value: true }
    ],
    password: [
      { key: 'required', value: true },
      { key: 'min', value: 8 }
    ],
    confirmPassword: [
      { key: 'required', value: true },
      { key: 'equals', value: password }
    ],
    phone: [{ key: 'required', value: true }],
    agreed: [{ key: 'required', value: true }]
  };

  useEffect(() => {
    Object.entries(fields).forEach(([field, value]) => {
      validateInput(field, value);
    });
  }, [displayName, email, password, confirmPassword, agreed]);

  const validateInput = (field, value) => {
    const rules = validation[field];
    const result = utils.fieldValidation(value, rules);
    setErrors(prev => ({
      ...prev,
      [field]: result.join(', ')
    }));
  };

  const handleConfirm = () => {
    const newUser = {
      displayName,
      email,
      password
    };
    onLoading(true);
    API.signup(newUser)
      .then(newUserResponse => {
        const info = {
          user: { id: newUserResponse.id, displayName: newUserResponse.displayName, email: newUserResponse.email }
        };
        API.signin(email, password)
          .then(loginResponse => {
            info.accessToken = loginResponse.accessToken;
            onLoading(false);
            onSuccess(info);
          })
          .catch(() => {
            onError(`Your user was created but login failed. Try to login again on homepage`);
          });
      })
      .catch(error => {
        onError(error);
      });
  };

  return (
    <>
      <div className="registration-header">
        <h2>We are grateful that you are interested in our product!</h2>
        <h3>let’s start this partnership, first with your profile settings</h3>
      </div>
      <div className="registration-form">
        <div className="form-group">
          <div className="row">
            <div className="col-6">
              <label>Name*</label>
              <CustomInput
                id="display-name"
                type="text"
                placeholder="Write your name"
                value={displayName}
                isEditable={true}
                onChange={e => {
                  setDisplayName(e.target.value);
                }}
                autoFocus={true}
                errorMessage={errors.displayName}
              />
            </div>
            <div className="col-6">
              <label>Email*</label>
              <CustomInput
                id="email"
                type="text"
                placeholder="Write your email"
                value={email}
                isEditable={true}
                onChange={e => {
                  setEmail(e.target.value);
                }}
                autoFocus={true}
                errorMessage={errors.email}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-6">
              <label>Password*</label>
              <CustomInput
                id="password"
                type="password"
                placeholder="Write your password"
                value={password}
                isEditable={true}
                onChange={e => {
                  setPassword(e.target.value);
                }}
                autoFocus={true}
                errorMessage={errors.password}
              />
            </div>
            <div className="col-6">
              <label htmlFor="name">Confirm Password*</label>
              <CustomInput
                id="confirm-password"
                type="password"
                placeholder="Confirm your password"
                value={confirmPassword}
                isEditable={true}
                onChange={e => {
                  setConfirmPassword(e.target.value);
                }}
                autoFocus={true}
                errorMessage={errors.confirmPassword}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <CustomCheckBox
                label={
                  <>
                    I accept the terms of license of AdMobilize. Read the terms {'\u00A0'}
                    <a href="https://admobilize.com/terms-and-conditions/" target="_blank" rel="noreferrer">
                      here
                    </a>
                    *
                  </>
                }
                selected={agreed ? 'all' : 'none'}
                onClick={value => {
                  setAgreed(!value);
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <CustomButton
        title={'Next'}
        classes="registration-button btn-primary"
        handleClick={handleConfirm}
        // handleClick={onSuccess}
        disabled={Object.values(errors).some(msg => msg)}
      />
    </>
  );
};

export default UserForm;
